import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenResponse } from '../../shared/models/logowanie.model';

@Injectable({
  providedIn: 'root',
})
export class LogowanieService {

  constructor(private http: HttpClient) { }

  google(accessToken: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>('/api/auth/login/google', accessToken);
  }

  facebook(accessToken: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>('/api/auth/login/facebook', accessToken);
  }

  token(token: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>('/api/auth/login/token', token);
  }

  zmienKlienta(klient: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>('/api/auth/login/klient', klient);
  }
}
